// extracted by mini-css-extract-plugin
export default {"modal-form-body":"ModalForm_modal-form-body__tcdnB","modal-form-header":"ModalForm_modal-form-header__U6ZIL","modal-form-footer":"ModalForm_modal-form-footer__6cXWq"};